//
// AHT Weight Management — Mysimba® (naltrexone/bupropion) Initial Supply Pathway
// Source: AHT_Mysimba_Clinical_Pathway.docx v1.0
//
// QUANTITIES ARE PRE-VERIFIED LOOKUPS. DO NOT CALCULATE.
// This pathway covers initial supply only: 7 × Mysimba® 8mg/90mg tablets (week 1 escalation).

import type { Pathway } from "../../types/pathway.types";
import {
  PGD_FRESH_CHECKS,
  mysimbaScreeningDownstreamNodes,
  mysimbaScreeningOutcomes,
} from "./_shared/mysimba-screening-downstream";

// ─────────────────────────────────────────────────────────────────────────────
// Node IDs
// ─────────────────────────────────────────────────────────────────────────────


// ─────────────────────────────────────────────────────────────────────────────
// Pathway
// ─────────────────────────────────────────────────────────────────────────────

export const ahtWtMysimbaInitialPathway: Pathway = {
  id: "aht-wt-mysimba-initial",
  name: "Mysimba® (naltrexone/bupropion) — Initial Supply",
  population: "Adults attending face-to-face for initial supply",
  pgdRefs: ["pgd-aht-wt-mysimba"],
  demographicConfiguration: { bannerFields: [] },
  entryNode: PGD_FRESH_CHECKS,

  nodes: [
    // ─────────────────────────────────────────────────────────────────────────
    // Steps 1–4 — shared screening downstream (PGD fresh checks, interaction
    // checks, cautions review, supply attestation). Single source of truth.
    // ─────────────────────────────────────────────────────────────────────────
    ...mysimbaScreeningDownstreamNodes,
  ],

  outcomes: mysimbaScreeningOutcomes,
};
